import { reducer } from '@ardoq/rxbeach';
import {
  changeActiveTab,
  fetchImportApiPayloadExamples,
  processImportApiPayloadExamplesError,
  processImportApiPayloadExamplesResponse,
  setCopiedTab,
  toggleShowDetails,
} from './actions';
import { ImportAPIPayloadExamplesResponse } from '@ardoq/api-types/integrations';
import { ErrorDetails, ImportApiPayloadDrawerState, TabType } from './types';
import { ASYNC_STATUS } from '../../types/api';

const setPayloadSuccess = (
  state: ImportApiPayloadDrawerState,
  payload: ImportAPIPayloadExamplesResponse
): ImportApiPayloadDrawerState => ({
  ...state,
  asyncStatus: ASYNC_STATUS.SUCCESS,
  payload,
  errorDetails: null,
});

const toggleActiveTab = (
  state: ImportApiPayloadDrawerState
): ImportApiPayloadDrawerState => ({
  ...state,
  activeTab: state.activeTab === 'objects' ? 'arrays' : 'objects',
});

const handleChangeActiveTab = reducer(changeActiveTab, toggleActiveTab);

const updateCopiedTab = (
  state: ImportApiPayloadDrawerState,
  copiedTab: TabType | null
): ImportApiPayloadDrawerState => ({
  ...state,
  copiedTab,
});

const handleSetCopiedTab = reducer(setCopiedTab, updateCopiedTab);

const updateShowDetails = (
  state: ImportApiPayloadDrawerState
): ImportApiPayloadDrawerState => ({
  ...state,
  showDetails: !state.showDetails,
});

const handleToggleShowDetails = reducer(toggleShowDetails, updateShowDetails);

const setLoadingForRequest = (
  state: ImportApiPayloadDrawerState
): ImportApiPayloadDrawerState => ({
  ...state,
  asyncStatus: ASYNC_STATUS.LOADING,
  errorDetails: null,
  showDetails: false,
});

const handleApiPayloadRequest = reducer(
  fetchImportApiPayloadExamples,
  setLoadingForRequest
);

const handleApiPayloadRequestSuccess = reducer(
  processImportApiPayloadExamplesResponse,
  setPayloadSuccess
);

const setApiPayloadError = (
  state: ImportApiPayloadDrawerState,
  errorDetails: ErrorDetails
): ImportApiPayloadDrawerState => ({
  ...state,
  asyncStatus: ASYNC_STATUS.FAILURE,
  errorDetails,
  payload: null,
});

const handleApiPayloadRequestFailed = reducer(
  processImportApiPayloadExamplesError,
  setApiPayloadError
);

export const reducers = [
  handleChangeActiveTab,
  handleSetCopiedTab,
  handleToggleShowDetails,
  handleApiPayloadRequest,
  handleApiPayloadRequestSuccess,
  handleApiPayloadRequestFailed,
];
